<template>
  <Dialog v-model:visible="visible" modal header="Recortar imagen" :closable="false" :style="{ width: '500px' }">
    
    <VuePictureCropper
      :img="image"
      :boxStyle="{ width: '500', height: 'auto' }"
      :options="{ viewMode: 1, dragMode: 'crop', aspectRatio: 1 }" />

    <template #footer>
      <button @click="cancel" class="px-3 py-2 bg-white border border-red-500 text-red-500 rounded hover:bg-red-500 hover:text-white">
        <i class="pi pi-times"></i>
        CANCELAR
      </button>
      <button @click="crop" class="px-3 py-2 bg-white border border-blue-500 text-blue-500 rounded hover:bg-blue-500 hover:text-white cursor-pointer">
        <font-awesome-icon :icon="['fas', 'scissors']" />
        RECORTAR
      </button>
    </template>

  </Dialog>
</template>

<script>
import VuePictureCropper, { cropper } from 'vue-picture-cropper'
import Dialog from 'primevue/dialog'

export default {
  name: 'CropImageModal',
  components: {
    VuePictureCropper,
    Dialog
  },
  props: {
    image: { type: String, required: true },
  },
  data() {
    return {
      visible: true,
    }
  },
  methods: {
    async crop() {
      const base64 = cropper.getDataURL()
      this.$emit('close', base64)
      this.visible = false
    },
    cancel() {
      this.$emit('close', null)
      this.visible = false
    },
  },
}
</script>